import React from "react";
import { Chip, Typography, Box } from "@mui/material";

interface BetaLabelProps {
    betaTitle: string;
}

export const BetaLabel = ({ betaTitle }: BetaLabelProps) => {

    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography noWrap fontSize={14} color="white">{betaTitle}</Typography>
            <Chip
                label="Beta"
                size="small"

                sx={{ height: 18, fontSize: 10, color: "common.white", backgroundColor: "orange.main" }}
            />
        </Box>
    );
};
